import { COUNTRY_MAP } from '../../constants/country-mapping';
import { POSTCODE_REGEXES } from './postcode-regexes';

export { CountryCode } from './postcode-types';

export const postcodeValidator = (
  postcode: string,
  country: string,
): boolean => {
  const countryCode = COUNTRY_MAP[country];

  if (!POSTCODE_REGEXES.has(countryCode)) {
    console.warn('Country code is unrecognized, skipping postcode validation');
    return true;
  }

  return POSTCODE_REGEXES.get(countryCode)?.test(postcode);
};

export const postcodeValidatorExistsForCountry = (country: string): boolean => {
  const countryCode = COUNTRY_MAP[country];

  return POSTCODE_REGEXES.has(countryCode);
};
